import * as types from '../mutation-types'
import { RO_ALGORITHM, RO_TRANSPORT_MODE } from '../../mixins/constants'
const VRP_SERVICES_RECOMMENDED = ['SGN-DG', 'HAN-DG']
const state = {
  singlePoint: null,
  inputSinglePoint: null,

  multiplePickupPointsMode: false,
  pickupPointList: [],
  deliveryTimeWindowsMode: false,

  multiplePoints: [],
  service: {},
  orderTime: 0,
  setOrderTimeForPickup: false,
  requests: [],

  settings: {
    type: null,
    optimize: false,
    stop_num: 0,
    min_stop_num: 0,
    max_stop_num: 0,
    same_size_required: false,
    roundtrip: false,
    max_cod: undefined,
    token: process.env.VUE_APP_SCV_KEY,
    dimensions: [],
    max_distance: 0
  },
  draftOrders: [],

  estimatingFee: false,
  creatingOrders: false,
  roParamsInput: {},
  customROParams: {},
  lastConfirmTime: null,
  currentStatusOfDataFromAPI: '',
  transportMode: undefined,
  normalOrder: true,

  haveGetFulfillmentOrder: false
}

// getters
const getters = {
  roSinglePoint: (state) => state.singlePoint,
  roInputSinglePoint: (state) => state.inputSinglePoint,
  roMultiplePoints: (state) => state.multiplePoints,
  roService: (state) => state.service,
  roOrderTime: (state) => state.orderTime,
  roRequests: (state) => state.requests,
  roSettings: (state) => state.settings,
  roDraftOrders: (state) => state.draftOrders,
  roEstimatingFee: (state) => state.estimatingFee,
  roCreatingOrders: (state) => state.creatingOrders,
  roParamsInput: (state) => state.roParamsInput,
  customROParams: (state) => state.customROParams,
  lastConfirmTime: (state) => state.lastConfirmTime,
  currentStatusOfDataFromAPI: (state) => state.currentStatusOfDataFromAPI,
  roSetOrderTimeForPickup: (state) => state.setOrderTimeForPickup,
  multiplePickupPointsMode: (state) => state.multiplePickupPointsMode,
  pickupPointList: (state) => state.pickupPointList,
  deliveryTimeWindowsMode: (state) => state.deliveryTimeWindowsMode,
  roTransportMode: (state) => {
    return state.settings.roundtrip ? RO_TRANSPORT_MODE.ROUNDTRIP : state.transportMode
  },
  recommendedAlgorithm: (state) => {
    const serviceId = state.service._id
    const isVRPRecommended = VRP_SERVICES_RECOMMENDED.indexOf(serviceId) > -1

    if (state.deliveryTimeWindowsMode) return RO_ALGORITHM.TWVRP
    if (state.multiplePickupPointsMode) return RO_ALGORITHM.SDVRP
    if (isVRPRecommended) return RO_ALGORITHM.VRP
    return RO_ALGORITHM.VRP
  },
  roNormalOrder: (state) => state.normalOrder,
  haveGetFulfillmentOrder: (state) => state.haveGetFulfillmentOrder
}

// actions
const actions = {
  resetROForm({ commit }) {
    commit(types.RESET_RO_FORM)
  },
  setROSinglePoint({ commit }, data) {
    commit(types.SET_RO_SINGLE_POINT, data)
  },
  setInputROSinglePoint({ commit }, data) {
    commit(types.SET_RO_INPUT_SINGLE_POINT, data)
  },
  setROMultiplePoints({ commit }, data) {
    commit(types.SET_RO_MULTIPLE_POINTS, data)
  },
  setROService({ commit }, data) {
    commit(types.SET_RO_SERVICE, data)
  },
  setROOrderTime({ commit }, data) {
    commit(types.SET_RO_ORDER_TIME, data)
  },
  setRORequests({ commit }, data) {
    commit(types.SET_RO_REQUESTS, data)
  },
  setROSettings({ commit }, data) {
    commit(types.SET_RO_SETTINGS, data)
  },
  setRODraftOrders({ commit }, data) {
    commit(types.SET_RO_DRAFT_ORDERS, data)
  },
  updateRODraftOrders({ commit }, data) {
    commit(types.UPDATE_RO_DRAFT_ORDERS, data)
  },
  updateARODraftOrder({ commit }, data) {
    commit(types.UPDATE_A_RO_DRAFT_ORDER, data)
  },
  resetRODraftOrders({ commit }) {
    commit(types.RESET_RO_DRAFT_ORDERS)
  },
  setROEstimatingFee({ commit }, data) {
    commit(types.SET_RO_ESTIMATING_FEE, data)
  },
  setROCreatingOrders({ commit }, data) {
    commit(types.SET_RO_CREATING_ORDERS, data)
  },
  setROParamsInput({ commit }, data) {
    commit(types.SET_JSON_PARAMS_INPUT, data)
  },
  setCustomROParams({ commit }, data) {
    commit(types.SET_CUSTOM_RO_PARAMS, data)
  },
  resetCustomROParams({ commit }) {
    commit(types.RESET_CUSTOM_RO_PARAMS)
  },
  setROSenderInfo({ commit }, data) {
    commit(types.SET_RO_SENDER_INFO, data)
  },
  setCurrentStatusOfDataFromAPI({ commit }, data) {
    commit(types.SET_CURRENT_STATUS_OF_DATA_FROM_API, data)
  },
  setTransportMode({ commit }, data) {
    commit(types.SET_TRANSPORT_MODE, data)
  },
  setMultiplePickupPointsMode({ commit }, data) {
    commit(types.SET_MULTIPLE_PICKUP_POINTS_MODE, data)
  },
  checkDeliveryTimeWindowsMode({ dispatch, state }) {
    const result = state.multiplePoints.some((p) => p.time_windows && p.time_windows.length === 2)

    dispatch('setDeliveryTimeWindowsMode', result)
  },
  setDeliveryTimeWindowsMode({ commit }, data) {
    commit(types.SET_DELIVERY_TIME_WINDOWS_MODE, data)
  },
  setPickupPointList({ commit }, data) {
    commit(types.SET_PICKUP_POINT_LIST, data)
  },
  setRONormalOrder({ commit }, data) {
    commit(types.SET_RO_NORMAL_ORDER, data)
  },
  setHaveGetFulfillmentOrder({ commit }, data) {
    commit(types.SET_HAVE_GET_FULFILLMENT_ORDER, data)
  }
}

// mutations
const mutations = {
  [types.RESET_RO_FORM](state) {
    state.singlePoint = null
    state.multiplePoints = []
    state.service = {}
    state.orderTime = 0
    state.setOrderTimeForPickup = false
    state.requests = []

    state.settings = {
      type: null,
      optimize: false,
      stop_num: 0,
      same_size_required: false,
      roundtrip: false,
      token: process.env.VUE_APP_SCV_KEY
    }
    state.draftOrders = []

    state.estimatingFee = false
    state.creatingOrders = false
    state.normalOrder = true
  },
  [types.SET_RO_SINGLE_POINT](state, data) {
    state.singlePoint = data
    // state.inputSinglePoint = data;
  },
  [types.SET_RO_INPUT_SINGLE_POINT](state, data) {
    state.inputSinglePoint = data
  },
  [types.SET_RO_MULTIPLE_POINTS](state, data) {
    state.multiplePoints = data
  },
  [types.SET_RO_SERVICE](state, data) {
    state.service = data
  },
  [types.SET_RO_ORDER_TIME](state, data) {
    state.orderTime = data.time
    if (data.setOrderTimeForPickup !== undefined) {
      state.setOrderTimeForPickup = data.setOrderTimeForPickup
    }
  },
  [types.SET_RO_REQUESTS](state, data) {
    state.requests = data
  },
  [types.SET_RO_SETTINGS](state, data) {
    state.settings = data
  },
  [types.SET_RO_DRAFT_ORDERS](state, data) {
    state.draftOrders = data
  },
  [types.UPDATE_RO_DRAFT_ORDERS](state, data) {
    state.draftOrders = data
  },
  [types.UPDATE_A_RO_DRAFT_ORDER](state, data) {
    const indexItem = state.draftOrders.findIndex((item) => {
      return item.order_index === data.item_index
    })

    const draftOrders = [...state.draftOrders]
    draftOrders.splice(indexItem, 1, data.item)
    state.draftOrders = [...draftOrders]

    if (!data.noSync) state.lastConfirmTime = new Date().getTime()
  },
  [types.RESET_RO_DRAFT_ORDERS](state) {
    state.draftOrders = []
  },
  [types.SET_RO_ESTIMATING_FEE](state, data) {
    state.estimatingFee = data
  },
  [types.SET_RO_CREATING_ORDERS](state, data) {
    state.creatingOrders = data
  },
  [types.SET_JSON_PARAMS_INPUT](state, data) {
    state.roParamsInput = data
  },
  [types.SET_CUSTOM_RO_PARAMS](state, data) {
    state.customROParams = data
  },
  [types.RESET_CUSTOM_RO_PARAMS](state) {
    state.customROParams = {}
  },
  [types.SET_RO_SENDER_INFO](state, data) {
    state.singlePoint = {
      ...state.singlePoint,
      ...data
    }
  },
  [types.SET_CURRENT_STATUS_OF_DATA_FROM_API](state, data) {
    state.currentStatusOfDataFromAPI = data
  },
  [types.SET_TRANSPORT_MODE](state, data) {
    state.transportMode = data
  },
  [types.SET_MULTIPLE_PICKUP_POINTS_MODE](state, data) {
    state.multiplePickupPointsMode = data
  },
  [types.SET_DELIVERY_TIME_WINDOWS_MODE](state, data) {
    state.deliveryTimeWindowsMode = data
  },
  [types.SET_PICKUP_POINT_LIST](state, data) {
    state.pickupPointList = data
  },
  [types.SET_RO_NORMAL_ORDER](state, data) {
    state.normalOrder = data
  },
  [types.SET_HAVE_GET_FULFILLMENT_ORDER](state, data) {
    state.haveGetFulfillmentOrder = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
